import axiosInstance from "@/api/axios";

export const fetchWatchedBuilders = async (query: { page: number; limit: number, q?:string }) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/builders/watched`,
      params: {
        page: query.page,
        limit: query.limit,
        ...(query.q && { q: query.q }), // Only add 'q' if it exists
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching watched builders:", err);
    throw err; // Re-throw error for better error handling
  }
}

export const removeWatchedBuilder = async (builder_id: number) => {
    try {
      const response = await axiosInstance.post(
        "/odoo/api/v1/builders/watchlist/remove",
        { builder_id } // Body
      );
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error removing watched builder:", err);
      throw err;
    }
  };
  